import * as t from "io-ts";

export const EntityGraphNodeCodec = t.intersection([
  t.type({
    id: t.string,
    label: t.string,
    type: t.string,
  }),
  t.partial({
    level: t.number,
    data: t.record(t.string, t.unknown),
  }),
]);

export type EntityGraphNode = t.TypeOf<typeof EntityGraphNodeCodec>;

export const EntityGraphEdgeCodec = t.intersection([
  t.type({
    id: t.string,
    source: t.string,
    target: t.string,
    directed: t.boolean,
  }),
  t.partial({
    label: t.string,
    data: t.record(t.string, t.unknown),
  }),
]);

export type EntityGraphEdge = t.TypeOf<typeof EntityGraphEdgeCodec>;

export const EntityGraphResponseCodec = t.intersection([
  t.type({
    nodes: t.array(EntityGraphNodeCodec),
    edges: t.array(EntityGraphEdgeCodec),
  }),
  t.partial({
    meta: t.record(t.string, t.unknown),
  }),
]);

export type EntityGraphResponse = t.TypeOf<typeof EntityGraphResponseCodec>;

export type EntityGraphOptions = {
  direction?: string
  maxUpDepth?: number
  maxDownDepth?: number
  bestDownTree?: boolean
  format?: string
}

export const groupEntityGraphNodesByLevel = (nodes: EntityGraphNode[]): Map<number, EntityGraphNode[]> => {
  const map = new Map<number, EntityGraphNode[]>();
  for (const n of nodes) {
    const lvl = typeof n.level === 'number' ? n.level : 0;
    if (!map.has(lvl)) {
      map.set(lvl, []);
    }
    map.get(lvl)?.push(n);
  }

  for (const arr of map.values()) {
    arr.sort((a, b) => a.label.localeCompare(b.label));
  }

  return new Map([...map.entries()].sort((a, b) => a[0] - b[0]));
}


export const computeEntityGraphLayout = (nodes: EntityGraphNode[], H = 220, V = 140) => {
  const byLevel = groupEntityGraphNodesByLevel(nodes);
  const positions = new Map<string, { x: number; y: number }>();
  let minLevel = 0;
  for (const lvl of byLevel.keys()) {
    minLevel = Math.min(minLevel, lvl);
  }
  for (const [lvl, arr] of byLevel.entries()) {
    const row = lvl - minLevel; // shift so min becomes 0
    arr.forEach((n, i) => positions.set(n.id, {x: i * H, y: row * V}));
  }
  return positions;
}
